export default "__VITE_ASSET__lf9mU6sc__"